import React, { memo } from "react";
import { useEffect } from "react";
import { useState } from "react";

/**
 * TopStripLoader (label fixed in center)
 */

const TopStripLoader = memo(
  ({
    mode='defined',
    loaderEnd=false,
    valueNow = 0,
    valueMax = 100,
    showPercent = true,
    barColor = "#389debff",
    textColor = "#fff",
    bgColor = "rgba(0,0,0,0.15)",
    height = "10px",
    fontSize = "1rem",
  }) => {

    const [value, setValue] = useState(0);

useEffect(() => {
  countToEightyIn2Seconds(setValue);
}, []);

function countToEightyIn2Seconds(onUpdate) {
  const target = 80;
  const duration = 2000; // 2 seconds
  const steps = 100;
  const interval = duration / steps;
  const increment = target / steps;

  let current = 0;

  const timer = setInterval(() => {
    current += increment;
    if (current >= target) {
      current = target;
      clearInterval(timer);
    }
    onUpdate(Math.round(current));
  }, interval);
}

    const percent = Math.min(100, Math.max(0, (valueNow / valueMax) * 100));
    const label = showPercent
      ? `${Math.round(percent)}%`
      : `${valueNow} / ${valueMax}`;

    /* ─── Styles ─────────────────────────────────────────── */
    const trackStyle = {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height:'5px',
      backgroundColor: bgColor,
      zIndex: 9999,
      overflow: "hidden",
      pointerEvents: "none",
    };
async function* percentage(duration = 2000, target = 80, steps = 100) {
  const interval = duration / steps;
  const increment = target / steps;
  let current = 0;

  for (let i = 0; i <= steps; i++) {
    yield Math.round(current);
    current += increment;
    await new Promise((res) => setTimeout(res, interval));
  }
}


    const barStyle = {
      width: `${mode == 'defined' ?percent :loaderEnd == false ? value :100 }%`,
      height: "100%",
      backgroundColor: barColor,
      transition: "width 200ms ease-out",
    };

    const labelStyle = {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: textColor,
      fontSize,
      fontWeight: "bold",
      whiteSpace: "nowrap",
      pointerEvents: "none",
    };

    /* ─── JSX ────────────────────────────────────────────── */
    return (
      <div
        style={trackStyle}
        role="progressbar"
        aria-valuenow={valueNow}
        aria-valuemin={0}
        aria-valuemax={valueMax}
      >
        <div style={barStyle} />
        {/* <div style={labelStyle}>{label}</div> */}
      </div>
    );
  }
);

export default TopStripLoader;
